<template>
    <div class="admin-user-games-element">
        <div class="element-section section-date">
            <div class="section-title">DATE</div>
            <div class="section-content">
                {{ new Date(game.createdAt).toLocaleString('en-US', { hour12: true, year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit' }) }}
            </div>
        </div>
        <div class="element-section section-game">
            <div class="section-title">GAME</div>
            <div class="section-content">
                {{adminGetGameName}}
            </div>
        </div>
        <div class="element-section section-id">
            <div class="section-title">GAME ID</div>
            <div class="section-content">
                {{game._id}}
            </div>
        </div>
        <div class="element-section section-bet">
            <div class="section-title">BET</div>
            <div class="section-content">
                <IconCoin />
                <div class="content-value">
                    <span>{{adminFormatValue(adminGetAmount).split('.')[0]}}</span>.{{adminFormatValue(adminGetAmount).split('.')[1]}}
                </div>
            </div>
        </div>
        <div class="element-section section-payout">
            <div class="section-title">PAYOUT</div>
            <div class="section-content">
                <IconCoin />
                <div class="content-value">
                    <span>{{adminFormatValue(adminGetPayout).split('.')[0]}}</span>.{{adminFormatValue(adminGetPayout).split('.')[1]}}
                </div>
            </div>
        </div>
        <div class="element-section section-profit">
            <div class="section-title">PROFIT</div>
            <div class="section-content">
                <IconCoin />
                <div class="content-value" v-bind:class="{ 'value-positive': adminGetProfit >= 0, 'value-negative': adminGetProfit < 0 }">
                    <span>{{adminFormatValue(adminGetProfit).split('.')[0]}}</span>.{{adminFormatValue(adminGetProfit).split('.')[1]}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconCoin from '@/components/icons/IconCoin';

    export default {
        name: 'AdminUserGamesElement',
        components: {
            IconCoin
        },
        props: [
            'game'
        ],
        methods: {
            adminFormatValue(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        },
        computed: {
            adminGetGameName() {
                // Format method name
                let gameName = this.game.method.charAt(0).toUpperCase() + this.game.method.slice(1);
                
                // Special handling for Duels
                if(this.game.method === 'duels') {
                    gameName = 'Dice Duels';
                }
                
                // For slots, show the actual slot game name if available
                if(this.game.method === 'slots' && this.game.gameName) {
                    return this.game.gameName;
                }
                
                return gameName;
            },
            adminGetAmount() {
                let amount = this.game.amount;

                if(this.game.method === 'blackjack') {
                    amount = Math.floor(this.game.amount.main + this.game.amount.sideLeft + this.game.amount.sideRight);
                    if(this.game.actions.includes('split') === true) { amount = Math.floor(amount + this.game.amount.main); }
                } else if(this.game.method === 'duels') {
                    amount = Math.floor(this.game.amount / 10) / 100;
                }
                // All other games (including slots) store amounts as $1 = 1

                return amount;
            },
            adminGetPayout() {
                let payout = this.game.payout;
                if(this.game.method === 'duels') {
                    payout = Math.floor(this.game.payout / 10) / 100;
                }
                return payout;
            },
            adminGetProfit() {
                return this.adminGetPayout - this.adminGetAmount;
            }
        }
    }
</script>

<style scoped>
    .admin-user-games-element {
        width: 100%;
        height: 47px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        border-radius: 5px;
    }

    .admin-user-games-element:nth-child(odd) {
        background-color: var(--bg-purple-dark);
    }

    .admin-user-games-element .element-section {
        display: flex;
        flex-direction: column;
    }

    .admin-user-games-element .element-section.section-date {
        width: 22%;
    }

    .admin-user-games-element .element-section.section-game {
        width: 12%;
    }

    .admin-user-games-element .element-section.section-id {
        width: 28%;
    }

    .admin-user-games-element .element-section.section-bet,
    .admin-user-games-element .element-section.section-payout,
    .admin-user-games-element .element-section.section-profit {
        width: 13%;
    }

    .admin-user-games-element .section-title {
        display: none;
        font-size: 13px;
        font-weight: 600;
        color: #8bacc8;
    }

    .admin-user-games-element .section-content {
        display: flex;
        align-items: center;
    }

    .admin-user-games-element .element-section.section-date .section-content,
    .admin-user-games-element .element-section.section-game .section-content,
    .admin-user-games-element .element-section.section-id .section-content {
        font-size: 14px;
        font-weight: 400;
        color: #bbbfd0;
    }

    .admin-user-games-element .element-section.section-bet .section-content,
    .admin-user-games-element .element-section.section-payout .section-content,
    .admin-user-games-element .element-section.section-profit .section-content {
        justify-content: flex-end;
    }

    .admin-user-games-element .element-section.section-bet .section-content img,
    .admin-user-games-element .element-section.section-payout .section-content img,
    .admin-user-games-element .element-section.section-profit .section-content img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }

    .admin-user-games-element .element-section.section-bet .content-value,
    .admin-user-games-element .element-section.section-payout .content-value,
    .admin-user-games-element .element-section.section-profit .content-value {
        font-size: 10px;
        font-weight: 600;
        color: #bbbfd0;
    }

    .admin-user-games-element .element-section.section-bet .content-value span,
    .admin-user-games-element .element-section.section-payout .content-value span,
    .admin-user-games-element .element-section.section-profit .content-value span {
        font-size: 14px;
        font-weight: 800;
    }

    .admin-user-games-element .element-section.section-bet .content-value span {
        color: #ff6b6b;
    }

    .admin-user-games-element .element-section.section-payout .content-value span {
        color: #ffffff;
    }

    .admin-user-games-element .element-section.section-profit .content-value.value-positive span {
        color: #00ffc2;
    }

    .admin-user-games-element .element-section.section-profit .content-value.value-negative span {
        color: #ff6b6b;
    }

    @media only screen and (max-width: 725px) {

        .admin-user-games-element {
            height: auto;
            flex-direction: column;
            align-items: flex-start;
            padding: 10px 20px;
        }

        .admin-user-games-element .element-section {
            width: 100%!important;
            margin-top: 10px;
        }

        .admin-user-games-element .element-section.section-date {
            margin-top: 0;
        }

        .admin-user-games-element .element-section.section-bet,
        .admin-user-games-element .element-section.section-payout,
        .admin-user-games-element .element-section.section-profit {
            align-items: flex-start;
        }

        .admin-user-games-element .element-section.section-bet .section-content,
        .admin-user-games-element .element-section.section-payout .section-content,
        .admin-user-games-element .element-section.section-profit .section-content {
            justify-content: flex-start;
        }

        .admin-user-games-element .section-title {
            display: block;
        }

        .admin-user-games-element .section-content {
            margin-top: 5px;
        }

    }
</style>
